import React, { memo, useContext } from "react";

// Utils

import styled from "styled-components";

import IcCheckOn from "../../../../../resources/images/icon/checkbox/checkbox_select.svg";
import IcImgBg from "../../../../../resources/images/icon/icon_image_wth_min.png";

import IcMapPin from "../../../../../resources/images/icon/trtmtData/card/Icon_map_pin.svg";
import IcTrtmtCircle from "../../../../../resources/images/icon/trtmtData/card/Icon_trtmt_circle.svg";
import IcTrtmtNew from "../../../../../resources/images/icon/trtmtData/card/Icon_trtmt_new.svg";
import IcTrtmt from "../../../../../resources/images/icon/trtmtData/card/Icon_trtmt_on.svg";

import { AppContext } from "../../../../../components/AppProvider";
import { mapLayer } from "../../../../common/Modal/NaverMap";
import ButtonLayer from "../ButtonLayer";

export default memo((props) => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const {
    data,
    dataList,
    setDeleteSeqNo,
    isCheckAll,
    setIsCheckAll,
    checkedSeqNo,
    setCheckedSeqNo,
    setLocationInfo,
    setSelectDataArray,
    setDeleteData,
    srchType,
    setCheckAll,
  } = props;

  const settingSeqNo = () => {
    let checkArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).attr("id"));
    });

    setSelectDataArray(checkArr);
  };

  // 전체 선택 기능 추가
  const checkedAll = () => {
    if (isCheckAll) {
      $("input:checkbox").prop("checked", false);
      settingSeqNo();
      setCheckAll(false);
    } else {
      $("input:checkbox").prop("checked", true);
      settingSeqNo();
      setCheckAll(true);
    }
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  const locationInfo = {
    addYn: "Y",
    address1: data.address1,
    address2: data.address2,
    address3: data.address3,
    address4: data.address4,
    distance: 0,
    hsptCd: data.hsptCd,
    hsptKey: data.hsptCd,
    hsptNm: data.hsptNm,
    latitude: data.lat,
    longitude: data.long,
    zipCode: data.zipCode,
  };

  return (
    <ListItem on="true">
      <ListItemInfoLayer on="true">
        <LineOneLayer>
          <div style={{ display: "flex" }}>
            <div
              style={{ display: "flex" }}
              onClick={() => {
                srchType ? settingSeqNo() : "";
              }}>
              <div>
                {srchType ? (
                  <ItemChecked
                    id={data.refKey}
                    type={"checkbox"}
                    name={"checkSeqNo"}
                  />
                ) : (
                  <ItemChecked
                    id={data.refKey}
                    type={"checkbox"}
                    name={"checkSeqNoX"}
                    disabled={true}
                  />
                )}
              </div>
              <div style={{ lineHeight: "45px" }}>
                <ItemDate>{data.studDt}</ItemDate>
              </div>
            </div>

            <div style={{ marginLeft: "auto" }}>
              {data.lat != "" && data.long != "" && (
                <ItemMap>
                  <Img
                    src={IcMapPin}
                    alt=""
                    onClick={() =>
                      mapLayer(phonecfg, setLocationInfo, locationInfo)
                    }
                  />
                </ItemMap>
              )}
              <ItemHospital>{data.hsptNm}</ItemHospital>
            </div>
          </div>
        </LineOneLayer>
        <LineTwoLayer>
          <div style={{ width: "26px" }}>
            {data.newYn == "Y" && (
              <Img
                src={IcTrtmtNew}
                verticalAlign={"text-top"}
                padding={"0px"}
                alt=""
              />
            )}
          </div>
          <div style={{ paddingLeft: "10px" }}>
            <Img
              src={IcTrtmt}
              verticalAlign={"text-top"}
              padding={"0px"}
              alt=""
            />
          </div>
          <ContentText on="true">{data.studNm}</ContentText>

          <div>
            {data.fileCnt > 0 && (
              <ImgCnt>
                <ImgCntI src={IcImgBg} />
                {data.fileCnt}
              </ImgCnt>
            )}
          </div>
          <div style={{ paddingLeft: "5px" }}>
            {data.fileCnt != 0 && data.fileCnt != data.dnCnt && (
              <Img
                src={IcTrtmtCircle}
                verticalAlign={"text-top"}
                padding={"0px"}
                alt=""
              />
            )}
          </div>
        </LineTwoLayer>
      </ListItemInfoLayer>
      {/* procType, seqNo, trtmtDt, hsptNm, trtmtNm, dataType, hsptCd */}

      <ButtonLayer
        btnType={"hospital"}
        on={"true"}
        procType={"D"}
        setDeleteData={setDeleteData}
        data={data}
      />
    </ListItem>
  );
});

/* css */

const ListItem = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  // gap: 85px;

  position: relative;
  width: 100%;
  height: 120px;
  margin: 0 0 12px 0; // 위, 오른쪽, 아래, 왼쪽

  background: #ffffff;
  border: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
  border-radius: 8px;
  border-bottom-width: medium;
`;

const ListItemInfoLayer = styled.div`
  width: 100%;
  height: 80px;
  display: inline-block;
  flex-direction: row;
  // border: 1px solid #FF0000;

  // border-bottom:1px solid #6A62E6;
  border-bottom: 1px solid ${(props) => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

const LineOneLayer = styled.div`
  width: 100%;
  height: 42px;
  line-height: 42px;
`;

const ItemChecked = styled.input`
  appearance: none !important;
  border: 1px solid #e0e0e0;
  border-radius: 1.5px;
  background-color: ${(props) => (props.disabled ? "#d9d9d9" : "#fff")} !important;
  width: 18px;
  height: 18px;

  margin-left: 16px;
  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;

const ItemDate = styled.div`
  color: #000000;

  display: inline-block;
  text-align: center;
  box-sizing: border-box;
`;

const ItemHospital = styled.div`
  // font-family: 'Pretendard';
  // font-style: normal;
  // font-weight: 400;
  // font-size: 14px;

  max-width: 127px;

  margin-right: 12px;
  color: #000000;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
  line-height: 45px !important;
`;

const Img = styled.img`
  vertical-align: middle;
  // padding-bottom: 3px;
`;

const ItemMap = styled.div`
  margin-right: 20px;

  display: inline-block;
  box-sizing: border-box;
  float: right;
`;

const LineTwoLayer = styled.div`
  // height: 46px;
  // display: inline-block;
  display: flex;
  box-sizing: border-box;

  height: 22px;
  // line-height: 22px;
  line-height: 20px;
  margin: 0 19px 0 17px;

  vertical-align: middle;
`;

const ContentText = styled.div`
  max-width: 58%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;

  margin-left: 10px;
  margin-right: 10px;

  display: inline-block;
  box-sizing: border-box;
  line-height: 22px;

  color: ${(props) => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const ImgCnt = styled.div`
  // position: absolute;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0px 5px;
  font-size: 10px;
  color: #fff;
  border-radius: 4px;
  background: #6a62e6;
`;

const ImgCntI = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(${(props) => props.src}) no-repeat center;
  background-size: contain;
  margin: 0 4px 0px 0;
`;
